import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";

export default {
    data: function() {
        return {
            lbl: Locale.getLbl(),
            localeCode: Locale.getLocaleCode(),
            locale: Locale,
        };
    },
    mounted: function() {
        var self = this;
       
        this.localeCheckInterval = setInterval(function() {
            var newLocaleCode = Locale.getLocaleCode();
            if (self.localeCode !== newLocaleCode) {
                self.localeCode = newLocaleCode;
                self.lbl = Locale.getLbl();
                self.$forceUpdate(); 
            }
        }, 300);
    },
    beforeDestroy: function() {
        if (this.localeCheckInterval) {
            clearInterval(this.localeCheckInterval);
        }
    },
    methods: {
        switchLang: function(locale) {
            this.locale.setLocale(locale);
            this.localeCode = Locale.getLocaleCode();
            this.lbl = Locale.getLbl();
            this.$forceUpdate();

            return new Promise((resolve, reject) => {
                if (Account.isLogin()) {
                    Account.apiUpdateProfileLocale(locale).then((profile) => {
                        if (this.profile)
                            this.profile = profile;
                        resolve ({locale: locale, profile: profile});
                    }).catch((err) => {
                        reject(err);
                    });
                } else {
                    resolve({locale: locale});
                }
            });
        },
    },
};
